import type { GetHomeQuizResponse } from '@tmap-web-lib/remote-api-client/frontman'

import { SvgObject } from '@/components'
import { useQuizCountdown } from '@/hooks/useQuizCountdown'
import { toUrl } from '@/utils'

import * as styles from './todayQuizCardV1.css'

export interface TodayQuizCardV1Props {
  homeQuizData: GetHomeQuizResponse
  onPress: () => void
}

function TodayQuizCardV1({ homeQuizData, onPress }: TodayQuizCardV1Props) {
  const { formattedTime } = useQuizCountdown(homeQuizData.endsDate ?? null)
  const { quizCategory, question, rewardType, rewardAmount } = homeQuizData

  return (
    <button
      className={styles.cardButton}
      onClick={onPress}
    >
      <div className={styles.badgeWrapper}>
        <span className={styles.quizBadgeText}>{quizCategory || '오늘의 퀴즈'}</span>
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.textArea}>
          <p className={styles.questionText}>{question.content}</p>
          <div className={styles.bottomRow}>
            {formattedTime && (
              <span className={styles.timerText}>{formattedTime}</span>
            )}
            {rewardType === 'TMAP_POINT' && rewardAmount > 0 && (
              <div className={styles.rewardBadge}>
                <SvgObject
                  src={toUrl('/assets/images/img_quiz_point.svg')}
                  width={18}
                  height={18}
                  fallbackSrc={toUrl(
                    require('../../../../../public/assets/images/img_quiz_point.svg').default
                  )}
                />
                <span className={styles.rewardText}>{rewardAmount}원</span>
              </div>
            )}
          </div>
        </div>

        <div className={styles.imageArea}>
          {question.type === 'ox' ? (
            <div className={styles.oxImageWrapper}>
              <SvgObject
                src={toUrl(require('../../../../assets/images/img_survey_O.svg'))}
                width={40}
                height={40}
              />
              <SvgObject
                src={toUrl(require('../../../../assets/images/img_survey_X.svg'))}
                width={40}
                height={40}
              />
            </div>
          ) : (
            <SvgObject
              src={toUrl(require('../../../../assets/images/img_survey_questionmark.svg'))}
              width={34}
              height={34}
            />
          )}
        </div>
      </div>
    </button>
  )
}

export { TodayQuizCardV1 }
